import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'ard-general-message-set-buttons-text-dialog',
	templateUrl: './general-message-set-buttons-text-dialog.component.html'
})
export class GeneralMessageSetButtonsTextDialogComponent implements OnInit {
	viewLoading: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<GeneralMessageSetButtonsTextDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { 
	}

	ngOnInit() {
		var aaa = this.data;
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	onYesClick(): void {
		this.viewLoading = true;
		this.dialogRef.close(true);
	}

	onYesDovizliClick(): void {
		this.dialogRef.close("DetayliDovizli");
	}

	onNoDovizliClick(): void {
		this.dialogRef.close("BasitDovizli");
	}
}
